import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductEnquiryForm = ({ product }) => {
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your name and phone number.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, {
        ...form,
        business_name: "",
        city: "",
        business_type: "",
        requirement: product.name,
        enquiry_type: "product",
      });
      toast.success("Enquiry received. The TMV Coffee team will reach out shortly.");
      setForm({ name: "", phone: "", message: "" });
    } catch {
      toast.error("Could not send your enquiry. Please try WhatsApp instead.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      data-testid="product-enquiry-form"
      onSubmit={submit}
      className="mt-8 rounded-sm border border-cream/10 bg-coffee/60 p-6"
    >
      <p className="font-display text-xl text-cream">
        Enquire about {product.name.replace("TMV ", "")}
      </p>
      <div className="mt-5 grid gap-5 sm:grid-cols-2">
        <input
          data-testid="product-enquiry-name-input"
          className="field-line"
          placeholder="Name *"
          value={form.name}
          onChange={set("name")}
        />
        <input
          data-testid="product-enquiry-phone-input"
          className="field-line"
          placeholder="Phone *"
          type="tel"
          value={form.phone}
          onChange={set("phone")}
        />
        <textarea
          data-testid="product-enquiry-message-input"
          className="field-line sm:col-span-2"
          rows="2"
          placeholder="Message (optional) — pack size, quantity..."
          value={form.message}
          onChange={set("message")}
        />
      </div>
      <button
        data-testid="product-enquiry-submit-button"
        type="submit"
        disabled={sending}
        className="mt-6 w-full rounded-full border border-gold py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold transition-all duration-300 hover:bg-gold hover:text-espresso disabled:opacity-50"
      >
        {sending ? "Sending..." : "Submit Enquiry"}
      </button>
    </form>
  );
};

export default ProductEnquiryForm;
